var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActive
    ? _c(
        "div",
        {
          staticClass: "booking-footer",
          class: [
            {
              "only-multiroom-switcher":
                !_vm.isOtherSteps && _vm.isMultiRoomActive,
            },
            { "--modify-booking-mode": _vm.isBookingEditMode },
            { "--is-multi-room": _vm.itemsInCart.length > 1 },
            { "--step-2": _vm.step === 2 },
            { "--compactFooter": _vm.isOverviewPage },
            { "--loggedOutFooter": _vm.isEnhancementsLoggedOut },
          ],
          attrs: { "data-component": "booking-footer" },
        },
        [
          _c(
            "div",
            {
              staticClass: "booking-footer-wrapper container",
              class: [{ "--modify-booking-mode": _vm.isBookingEditMode }],
            },
            [
              _vm.isBookingEditMode || _vm.isOtherSteps
                ? _c("div", { staticClass: "booking-footer-summary" }, [
                    _c(
                      "div",
                      { staticClass: "booking-footer-summary-wrapper" },
                      [
                        _c(
                          "div",
                          { staticClass: "booking-footer-summary-total" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.tc("booking.total")) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getDisplayPrice({ price: _vm.cartTotal })
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "booking-footer-summary-details" },
                          [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.$emit("show-cart")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.tc("booking.details")))]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isBookingEditMode &&
                    _vm.step === 0 &&
                    !_vm.isOverviewPage
                      ? _c(
                          "div",
                          { staticClass: "booking-footer-special-code" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "booking-footer-special-code-cta",
                                class: {
                                  "booking-footer-special-code-cta_selected":
                                    _vm.havePromoValues,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.handleSpecialCodeClick($event)
                                  },
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.handleSpecialCodeClick($event)
                                  },
                                },
                              },
                              [
                                _vm.havePromoValues
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "booking-footer-special-code-cta-text",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.promoValue) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "icon-close" }),
                                    ]
                                  : [
                                      _c("div", { staticClass: "icon-plus" }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "booking-footer-special-code-cta-text",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.tc("booking.add")) +
                                              " " +
                                              _vm._s(
                                                _vm.tc("booking.specialCode")
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isMultiRoomActive && !_vm.multiBookingCheckboxIsActive
                ? _c("div", { staticClass: "booking-footer-rooms-switcher" }, [
                    _c(
                      "button",
                      {
                        staticClass: "switch",
                        attrs: { disabled: _vm.disableBackButton },
                        on: {
                          click: function ($event) {
                            return _vm.selectRoom(_vm.previousRoomId)
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            ) {
                              return null
                            }
                            return _vm.selectRoom(_vm.previousRoomId)
                          },
                        },
                      },
                      [_c("em", { staticClass: "icon-chevron-left" })]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "room-info" }, [
                      _c(
                        "div",
                        { staticClass: "title" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.tc("booking.selectMultipleRooms", {
                                  currentRoom: _vm.currentRoomId + 1,
                                  totalRooms: Number(_vm.query.roomQuantity),
                                })
                              ) +
                              "\n          "
                          ),
                          _vm.showTooltip
                            ? _c(
                                "v-dropdown",
                                {
                                  staticClass:
                                    "tooltip tooltip-variant--booking-footer",
                                  attrs: {
                                    placement: "top",
                                    distance: 22,
                                    skidding: 0,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "popper",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tooltip-variant--booking-footer tooltip-content",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tooltip-header",
                                                  },
                                                  [
                                                    _c("span", {
                                                      directives: [
                                                        {
                                                          name: "close-popper",
                                                          rawName:
                                                            "v-close-popper",
                                                        },
                                                      ],
                                                      staticClass: "icon-close",
                                                      attrs: {
                                                        "aria-label":
                                                          _vm.tc(
                                                            "booking.close"
                                                          ),
                                                        tabindex: "0",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "tooltip-body",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.tooltipLabel
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1610021645
                                  ),
                                },
                                [
                                  _c("button", {
                                    staticClass: "tooltip-icon icon-info",
                                    attrs: {
                                      role: "presentation",
                                      "aria-label": _vm.tooltipLabel,
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "subtitle" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.currentRoomGuestsSummary) +
                            "\n        "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "switch",
                        attrs: { disabled: _vm.disableNextButton },
                        on: {
                          click: function ($event) {
                            return _vm.selectRoom(_vm.currentRoomId + 1)
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            ) {
                              return null
                            }
                            return _vm.selectRoom(_vm.currentRoomId + 1)
                          },
                        },
                      },
                      [_c("em", { staticClass: "icon-chevron-right" })]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isBookingEditMode || _vm.isOtherSteps
                ? _c("div", { staticClass: "booking-footer-skip" }, [
                    _vm.isMultiRoomActive &&
                    _vm.stepZeroActive &&
                    !_vm.currentRoomIsLastRoom
                      ? _c(
                          "button",
                          {
                            class: _vm.nextStepClass,
                            attrs: { disabled: _vm.disableSkipButton },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.selectRoom(_vm.currentRoomId + 1)
                              },
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.selectRoom(_vm.currentRoomId + 1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.tc("booking.skipToRoomSelection", {
                                    nextRoomId: _vm.currentRoomId + 2,
                                  })
                                ) +
                                "\n      "
                            ),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            class: _vm.nextStepClass,
                            attrs: { disabled: _vm.disableSkipButton },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.buttonAction($event)
                              },
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.buttonAction($event)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.multiBookingCheckboxIsActive
                                    ? _vm.tc("booking.continueToOverview")
                                    : _vm.nextStepLabel
                                ) +
                                "\n      "
                            ),
                          ]
                        ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }